module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cpaCommission-box"
  }, [_c('div', {
    staticClass: "tableBtn-box",
    style: (_vm.version == '0' ? 'visibility:hidden;' : '')
  }, [_c('button', {
    staticClass: "btn btn-style-add",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.addLots) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-style-remove",
    attrs: {
      "disabled": !_vm.commission.enable || _vm.version == '0'
    },
    on: {
      "click": _vm.removeItem
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash"
  }), _vm._v("\n        " + _vm._s(_vm.multiLanguage.btnGroup.removeLots) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-box"
  }, [_c('table', {
    staticClass: "table table-bordered",
    class: {
      'table-striped': _vm.commission.enable && _vm.version == '1',
      'disabled': !_vm.commission.enable || _vm.version == '0'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.multiLanguage.CPA.totalVolume) + " >= 25 " + _vm._s(_vm.multiLanguage.CPA.LOT) + "(" + _vm._s(_vm.multiLanguage.CPA.remarks) + ")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.multiLanguage.CPA.commissionPer))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.commission.cpa), function(cpaItem, index) {
    return _c('tr', [_c('td', [(_vm.version == '1') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedCPAS),
        expression: "checkedCPAS"
      }],
      class: {
        'min-checkbox': _vm.viewBtn == 'double'
      },
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.commission.enable || _vm.version == '0'
      },
      domProps: {
        "value": index,
        "checked": Array.isArray(_vm.checkedCPAS) ? _vm._i(_vm.checkedCPAS, index) > -1 : (_vm.checkedCPAS)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedCPAS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = index,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedCPAS = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedCPAS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedCPAS = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cpaItem.start),
        expression: "cpaItem.start"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:1.00|decimal:2'),
        expression: "'required|min_value:1.00|decimal:2'"
      }],
      style: (_vm.errors.has(index + '_' + 'cpaStart') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": index + '_' + 'cpaStart'
      },
      domProps: {
        "value": (cpaItem.start)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cpaItem, "start", $event.target.value)
        }
      }
    }) : _c('span', {
      staticClass: "cpa-text"
    }, [_vm._v(_vm._s(cpaItem.start ? cpaItem.start : '1.00'))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), (index !== _vm.commission.cpa.length - 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cpaItem.end),
        expression: "cpaItem.end"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:1.00|decimal:2'),
        expression: "'required|min_value:1.00|decimal:2'"
      }],
      style: (_vm.errors.has(index + '_' + 'cpaEnd') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": index + '_' + 'cpaEnd'
      },
      domProps: {
        "value": (cpaItem.end)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cpaItem, "end", $event.target.value)
        }
      }
    }) : _c('span', {
      staticClass: "cpa-text"
    }, [_vm._v(_vm._s(_vm.multiLanguage.infinite))])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cpaItem.CPA),
        expression: "cpaItem.CPA"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|min_value:0.01|decimal:2'),
        expression: "'required|min_value:0.01|decimal:2'"
      }],
      style: (_vm.errors.has(index + '_' + 'cpaData') ? 'border-color:#f44336;' : ''),
      attrs: {
        "type": "text",
        "disabled": !_vm.commission.enable || _vm.version == '0',
        "name": index + '_' + 'cpaData'
      },
      domProps: {
        "value": (cpaItem.CPA)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cpaItem, "CPA", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span')])])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ff851bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBSetting/cpaCommission.vue
// module id = 1090
// module chunks = 1